import axios from 'axios';
import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Add token to requests
const getAuthHeaders = () => {
  const token = authService.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

class AdminService {
  // ========== SERVICES ==========

  // Get all services
  async getServices() {
    try {
      const response = await axios.get(`${API_URL}/admin/services`, {
        headers: getAuthHeaders()
      });
      return { success: true, services: response.data.services };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch services'
      };
    }
  }

  // Get single service
  async getService(id) {
    try {
      const response = await axios.get(`${API_URL}/admin/services/${id}`, {
        headers: getAuthHeaders()
      });
      return { success: true, service: response.data.service };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch service'
      };
    }
  }

  // Create service
  async createService(formData) {
    try {
      const response = await axios.post(
        `${API_URL}/admin/services`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return { success: true, service: response.data.service };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create service'
      };
    }
  }

  // Update service
  async updateService(id, formData) {
    try {
      const response = await axios.put(
        `${API_URL}/admin/services/${id}`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return { success: true, service: response.data.service };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update service'
      };
    }
  }

  // Delete service
  async deleteService(id) {
    try {
      const response = await axios.delete(`${API_URL}/admin/services/${id}`, {
        headers: getAuthHeaders()
      });
      return { success: true, message: response.data.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete service'
      };
    }
  }

  // Toggle service active status
  async toggleServiceActive(id) {
    try {
      const response = await axios.post(
        `${API_URL}/admin/services/${id}/toggle-active`,
        {},
        { headers: getAuthHeaders() }
      );
      return { success: true, service: response.data.service };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to toggle service status'
      };
    }
  }
}

export default new AdminService();
